import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard } from '../../Components/Common/DashboardKit';
import 'react-toastify/dist/ReactToastify.css';

/**
 * Accounting module landing page.
 *
 * UI-only refactor (Pass 1):
 *  - Replaced the legacy <BreadCrumb> with the standard
 *    <DashboardPageHeader> so the page matches the rest of the
 *    dashboard.
 *  - Replaced the video-based <ComingSoon> block with the flat
 *    <ComingSoonCard> from the DashboardKit. No autoplaying media,
 *    sits naturally below the header.
 *
 * No business logic — the route is already wrapped in
 * <RoleProtected requireAny={["Manager", "HR Admin", "IT Admin"]}>
 * in allRoutes.js, so this component renders only for authorized
 * users. Dead imports (api, DigitalClock, avatar, react-toastify,
 * etc.) were removed because they were unused after the visual
 * cleanup.
 */
const Accounting = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-bank-line"
                        eyebrow="Finance"
                        title="Accounting"
                        subtitle="Ledger, billing, and financial reporting"
                        tone="default"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Accounting" },
                        ]}
                    />

                    <ComingSoonCard
                        icon="ri-bank-line"
                        title="Accounting tools are coming soon"
                        message="The accounting workspace is being built out. You'll be able to track invoices, payments, and financial reports from here once it's live."
                        tone="primary"
                        features={[
                            "Invoice and AR/AP tracking",
                            "Vendor payment workflows",
                            "Monthly close checklists",
                            "Drill-down financial reports",
                        ]}
                        contact="Reach out to the Finance team for ETA updates."
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Accounting;
